// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2bDtw","search":"Settings_search__381LC","filter":"Settings_filter__iUI9F"};